import { render, staticRenderFns } from "./Marketing_dashboard.vue?vue&type=template&id=3ae3175a&"
import script from "./Marketing_dashboard.vue?vue&type=script&lang=js&"
export * from "./Marketing_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports